const ID_OPERATORS = ["eq", "!eq", "in", "!in"];

const publicApiSchema = {
  $id: "/publicapi",
  type: "object",
  properties: {
    credentials: {
      type: "array",
      items: {
        type: "object",
        properties: {
          audience: { type: "string", readOnly: true },
          clientId: { type: "string", validOperators: ID_OPERATORS },
          clientSecret: { type: "string", readOnly: true },
          created: { type: "string", format: "date-time", readOnly: true },
          modified: { type: "string", format: "date-time", readOnly: true },
          url: { type: "string", readOnly: true },
        },
      },
    },
    id: { type: "string", format: "uuid", validOperators: ID_OPERATORS },
  },
  required: [],
  additionalProperties: false,
};

export default publicApiSchema;
